// eslint-disable-next-line jira/restricted/relay-runtime
import { Environment } from 'relay-runtime';
import { getRelayEnvironmentConfig } from '@atlassian/jira-relay-environment-config';

const environmentConfig = getRelayEnvironmentConfig();

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default new Environment(environmentConfig);
